<qp-button
    [icon]="Icons.device_upgrade"
    [name]="AppStrings.Device_Upgrade"
    [label]="AppStrings.Device_Upgrade"
    [colour]="''"
    [outline]="false"
    [disabled]="disabled"

    (clickL)="onClick($event)"
>
</qp-button>